import { Control, useWatch } from 'react-hook-form';
import {
  AccordionButton,
  AccordionIcon,
  AlertSuccessIcon,
  Circle,
  HStack,
  ReloadIcon,
  Text,
  VStack,
} from '@cdl/heartbeat-react';
import { FormValues } from '../../types/annotation-task-detail.type';

type Props = {
  control: Control<FormValues>;
};

export const GeneralDataHeader: React.FC<Props> = ({ control }) => {
  const fieldNames = [
    'name',
    'description',
    'priority',
    'nb_annotations',
    'dataset_id',
    'annotation_grid',
  ];

  const watchedFields = useWatch({
    control,
    name: fieldNames,
  });

  const filledFieldsCount = watchedFields.filter((value) => value).length;

  const displayFields = fieldNames
    .map((name, index) => ({
      name,
      value: watchedFields[index],
    }))
    .filter(({ value }) => value)
    .map(
      ({ name, value }) =>
        `${name.charAt(0).toUpperCase() + name.slice(1)}: ${value}`,
    )
    .join(' - ');

  const renderIcon = () => {
    switch (filledFieldsCount) {
      case 6:
        return <AlertSuccessIcon size='s' color='green.400' m='s' />;
      case 0:
        return <Circle size='16px' m='s' border='1px' />;
      default:
        return <ReloadIcon size='s' color='orange.400' m='s' />;
    }
  };

  return (
    <AccordionButton
      justifyContent='space-between'
      textAlign='left'
      p='l'
      borderBottom='1px'
      borderColor='neutral.100'
    >
      <HStack gap={2}>
        {renderIcon()}
        <VStack alignItems='flex-start'>
          <Text textStyle='page-subtitle'>General Information*</Text>
          {filledFieldsCount > 0 && (
            <Text
              fontStyle='paragraph'
              color={filledFieldsCount === 6 ? 'green.400' : 'orange.400'}
            >
              {filledFieldsCount} of 6 inputs completed
            </Text>
          )}
        </VStack>
        <Text pl='xl' color='neutral.300' as='span'>
          {filledFieldsCount > 0 ? displayFields : 'No information set'}
        </Text>
      </HStack>
      <AccordionIcon />
    </AccordionButton>
  );
};
